import React, { useState, useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";

import CurrentPlayers from "../components/CurrentPlayers";
import TriviaSubmit from "assets/images/sbs/TriviaSubmit.png";
import checkBox from "assets/images/sbs/inputSelect.png";
import checkBoxFilled from "assets/images/sbs/inputFilled.png";

const QuestionSubmit = ({
  key,
  users,
  asker,
  roomId,
  isAsker,
  playAudio,
  mobile_app,
  sbsReducer,
  set_answers,
  set_question,
  select_sound,
  choose_answer,
  reset_lts_state,
  set_correct_answer,
  question_submit_params
}) => {
  const answers = _.get(sbsReducer, "answers");
  const question = _.get(sbsReducer, "question");
  const correct_answer = _.get(sbsReducer, "correct_answer");
  const bottom_text = _.get(
    question_submit_params,
    "bottom_text",
    "is entering the question!"
  );
  const current_players_label = _.get(
    question_submit_params,
    "current_players_label",
    "Current Players:"
  );
  const asker_label = _.get(
    question_submit_params,
    "asker_label",
    "You're the Asker!"
  );
  const question_label = _.get(
    question_submit_params,
    "question_label",
    "What is your question?"
  );
  const question_hint = _.get(
    question_submit_params,
    "question_hint",
    "Enter Question"
  );
  const answers_label = _.get(
    question_submit_params,
    "answers_label",
    "Enter your answers and select which one is correct"
  );
  const answer_a_hint = _.get(
    question_submit_params,
    "answer_a_hint",
    "Answer A"
  );
  const answer_b_hint = _.get(
    question_submit_params,
    "answer_b_hint",
    "Answer B"
  );
  const answer_c_hint = _.get(
    question_submit_params,
    "answer_c_hint",
    "Answer C"
  );
  const answer_d_hint = _.get(
    question_submit_params,
    "answer_d_hint",
    "Answer D"
  );
  const submit_question = _.get(
    question_submit_params,
    "submit_question",
    "Submit Question"
  );

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    question !== "" && !answers.includes("") && correct_answer.some(Boolean)
      ? setButtonDisabled(false)
      : setButtonDisabled(true);
  }, [question, answers, correct_answer]);

  const handleInputChange = (e, index) => {
    let array = [...answers];
    array[index] = e.target.value;
    set_answers(array);
  };

  const handleInputSelect = (index) => {
    playAudio(choose_answer);
    let array = [false, false, false, false];
    array[index] = true;
    set_correct_answer(array);
  };

  const handleSubmit = () => {
    playAudio(select_sound);
    const questions = [
      {
        question: question,
        answers: answers,
        correct_answer: correct_answer.findIndex(
          (value, index) => value || (value && index === 0)
        )
      }
    ];
    if (mobile_app) {
      const message = {
        action: "lt-submit-question",
        questions
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "lt-submit-question",
        roomId: roomId,
        questions
      };
      Socket.sendMessage(data);
    }
    setTimeout(() => {
      reset_lts_state();
    }, 2000);
  };

  const divVariants = {
    hidden: {},
    visible: {},
    exit: {}
  };
  const textVariants = {
    hidden: { opacity: 0.4, scale: 0.2 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.2 }
  };
  const buttonVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw" }
  };

  return isAsker ? (
    <div key={key} className="container SubmitTrivia-container">
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="Lightning-trivia-Wrapper SubmitTrivia-questionAnswer"
      >
        <img src={TriviaSubmit} className="logoimage" alt="sbsLogo" />
        <motion.div
          variants={buttonVariants}
          className={`question-asker ${mobile_app ? "mobile-cnt" : "web-cnt"}`}
        >
          <motion.h2 variants={textVariants} className="mediamText">
            {asker_label}
          </motion.h2>
          <motion.h3
            variants={textVariants}
            className="mediamText blueText m-0"
          >
            {question_label}
          </motion.h3>
          <motion.textarea
            variants={buttonVariants}
            rows="3"
            value={question}
            className="questionArea"
            placeholder={question_hint}
            onChange={(e) => set_question(e.target.value)}
          />
          <motion.p variants={textVariants}>{answers_label}</motion.p>
          <div className="inputWrapper">
            {[...Array(4).keys()].map((_, index) => (
              <motion.div
                key={index}
                variants={buttonVariants}
                className="selectAnswer-wrapper"
              >
                <input
                  rows="1"
                  type="text"
                  value={answers[index]}
                  onChange={(e) => handleInputChange(e, index)}
                  className="GiovanniInput mediamText darkBlueText"
                  placeholder={`${
                    index === 0
                      ? answer_a_hint
                      : index === 1
                      ? answer_b_hint
                      : index === 2
                      ? answer_c_hint
                      : answer_d_hint
                  }`}
                />
                <div className="check-box-cnt">
                  <img
                    alt=""
                    src={checkBox}
                    className="input"
                    onClick={() => handleInputSelect(index)}
                  ></img>
                  {correct_answer[index] && (
                    <div className="div-fill">
                      <img
                        className="input-filled"
                        src={checkBoxFilled}
                        alt=""
                      />
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
        <motion.button
          type="submit"
          variants={buttonVariants}
          disabled={buttonDisabled}
          onClick={() => handleSubmit()}
          className={`${
            buttonDisabled ? "sbsButton sbsDarkButton" : "mt15 sbsButton"
          }`}
        >
          {submit_question}
        </motion.button>
      </motion.div>
    </div>
  ) : (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      key={key}
      className="container"
    >
      <div className="Lightning-trivia-Wrapper SubmitTrivia-question">
        <img src={TriviaSubmit} className="logoimage" alt="sbsLogo" />
        <motion.h2 variants={textVariants} className="mediamText blueText">
          {asker.display_name}
        </motion.h2>
        <motion.p variants={textVariants} className="mediamText blueText mb52">
          {bottom_text}
        </motion.p>
        <motion.h3 variants={textVariants} className="mediamText blueText">
          {current_players_label}
        </motion.h3>
        <CurrentPlayers users={users} />
      </div>
    </motion.div>
  );
};

export default QuestionSubmit;
